import * as React from 'react';

import TranslationActions from 'actions/TranslationActions';
// @ts-ignore
import LanguageHoverCard from 'chat/components/LanguageHoverCard';
import errorLogger from 'utils/errorLogger';
import ComposerTranslationsHoverCard from './ComposerTranslationsHoverCard';
import CurrentUser from 'auth/CurrentUser';

import TooltipHovercardIconButton from './TooltipHovercardIconButton';

export type Props = {
  onTextChange?: (text: string) => void;
  onLangChange?: (lang: string) => void;
  textToTranslate: string;
  className?: string;
  eventKey?: string;
  eventProperties?: { [key: string]: any };
  dataTestSelector?: string;
};

class TranslateButton extends React.Component<Props> {
  handleTranslateTo = (
    lang: string,
    text: string,
    onTextChange?: (text: string) => void,
    onLangChange?: (lang: string) => void
  ) => {
    TranslationActions.translate(text, lang)
      .then(response => {
        if (onLangChange) {
          onLangChange(lang);
        }
        if (onTextChange) {
          onTextChange(response.translation);
        }
      })
      .catch(errorLogger('TranslateButton translate failed'));
  };

  hasNewTranslationsEnabled() {
    return CurrentUser?.getUser()?.hasFeature('2020.dec.preferred_language_translation_v0');
  }

  render() {
    const { textToTranslate, onTextChange, onLangChange, ...props } = this.props;
    const disabled = !textToTranslate;
    return (
      <TooltipHovercardIconButton
        icon="globe-stroked"
        layerPlacement="top"
        layerAlignment="left"
        disabled={disabled}
        layer={
          this.hasNewTranslationsEnabled() ?
          <ComposerTranslationsHoverCard />
          :
          <LanguageHoverCard
            onLanguagePicked={(lang: string) =>
              this.handleTranslateTo(lang, textToTranslate, onTextChange, onLangChange)
            }
            eventProperties={{
              composer_version: 'web_full_page',
            }}
          />
        }
        tooltipText={disabled ? 'Type your message to translate it' : 'Translate'}
        {...props}
      />
    );
  }
}

export default TranslateButton;
